import React, { Component } from "react";
import { connect } from "react-redux";
import otherTransactionFeesTotal from "../selectors/otherTransactionFeesTotal.selector";
import TextInput from "../components/TextInput";

import {
  setDriverLicenseIdFee,
  setPropertyTaxFee,
  setHuntingFishingFee,
} from "../redux/modules/otherTransactionFees";

class OtherTransactionFees extends Component {
  render() {
    return (
      <div className="Box">
        <div className="SalesTax">
          <div className="Row Title-feeRow">
            <input
              id="DriversLicenseIdFee"
              data-id="totalDriversLicenseIdFee"
              data-tooltip="Enter the total fees paid for your driver's license or offcial ID card."
              type="number"
              value={this.props.driversLicenseIdFee}
              onChange={(event) =>
                this.props.onChangeDriversLicenseIdFee(event.target.value)
              }
              className="Row-total Row-editableTotal"
            />

            <b className="no-print">Enter Driver License / ID Card Fees</b>
            <b className="print-label print-only">
              Total Driver License / ID Card Fees
            </b>
          </div>

          <div className="Row Title-feeRow">
            <input
              id="PropertyTaxFee"
              data-id="totalPropertyTaxFee"
              data-tooltip="Enter the total Property Tax fee."
              type="number"
              value={this.props.propertyTaxFee}
              onChange={(event) =>
                this.props.onChangePropertyTaxFee(event.target.value)
              }
              className="Row-total Row-editableTotal"
            />

            <b className="no-print">Enter Property Tax Fees</b>
            <b className="print-label print-only">Total Property Tax Fees</b>
          </div>

          <div className="Row Title-feeRow">
            <input
              id="HuntingFishingFee"
              data-id="totalHuntingFishingFee"
              data-tooltip="Enter the total Hunting and Fishing fee."
              type="number"
              value={this.props.huntingAndFishingFee}
              onChange={(event) =>
                this.props.onChangeHuntingAndFishingFee(event.target.value)
              }
              className="Row-total Row-editableTotal"
            />

            <b className="no-print">Enter Hunting and Fishing Fees</b>
            <b className="print-label print-only">
              Total Hunting and Fishing Fees
            </b>
          </div>

          <div className="Row Row-finalTotalRow">
            <TextInput
              tabIndex="-1"
              className="Row-total Row-finalTotal"
              id="ONewTotal"
              tooltip="Registration Total"
              value={this.props.total || "0.00"}
              readOnly
            />
            <label className="Row-finalTotalLabel" htmlFor="ONewTotal">
              OTHER FEES TOTAL
            </label>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    driversLicenseIdFee: state.otherTransactionFees.driversLicenseIdFee,
    propertyTaxFee: state.otherTransactionFees.propertyTaxFee,
    huntingAndFishingFee: state.otherTransactionFees.huntingAndFishingFee,
    total: otherTransactionFeesTotal(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeDriversLicenseIdFee: (fee) => dispatch(setDriverLicenseIdFee(fee)),
    onChangePropertyTaxFee: (fee) => dispatch(setPropertyTaxFee(fee)),
    onChangeHuntingAndFishingFee: (fee) => dispatch(setHuntingFishingFee(fee)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OtherTransactionFees);
